// This file is auto-generated by @hey-api/openapi-ts

export const ActionSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        method: {
            type: 'string',
            title: 'Method'
        },
        href: {
            type: 'string',
            title: 'Href'
        },
        operation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Operation'
        }
    },
    type: 'object',
    required: ['name', 'title', 'method', 'href', 'operation'],
    title: 'Action',
    description: 'Action.'
} as const;

export const ArtefactSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        mimetype: {
            type: 'string',
            title: 'Mimetype'
        },
        links: {
            additionalProperties: {
                '$ref': '#/components/schemas/Hateoas'
            },
            type: 'object',
            title: 'Links',
            default: {}
        }
    },
    type: 'object',
    required: ['identity', 'name', 'mimetype'],
    title: 'Artefact',
    description: 'Response body for Artefact.'
} as const;

export const ArtefactGroupWithArtefactsSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        artefacts: {
            items: {
                anyOf: [
                    {
                        '$ref': '#/components/schemas/Artefact'
                    },
                    {
                        '$ref': '#/components/schemas/ArtefactGroupWithArtefacts'
                    }
                ]
            },
            type: 'array',
            title: 'Artefacts'
        }
    },
    type: 'object',
    required: ['identity', 'name', 'artefacts'],
    title: 'ArtefactGroupWithArtefacts',
    description: 'Response body for Artefact group with artefacts.'
} as const;

export const Body_start_biz_artefact_management_add_artefact_group_start_postSchema = {
    properties: {
        owner_id: {
            type: 'string',
            title: 'Owner Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: ['owner_id', 'name'],
    title: 'Body_start_biz_artefact_management_add_artefact_group_start_post'
} as const;

export const Body_start_biz_artefact_management_add_artefact_start_postSchema = {
    properties: {
        owner_id: {
            type: 'string',
            title: 'Owner Id'
        },
        file_: {
            type: 'string',
            format: 'binary',
            title: 'File '
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: ['owner_id', 'file_'],
    title: 'Body_start_biz_artefact_management_add_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_get_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: ['artefact_id'],
    title: 'Body_start_biz_artefact_management_get_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_get_artefacts_tree_start_postSchema = {
    properties: {
        artefact_group_id: {
            type: 'string',
            title: 'Artefact Group Id'
        }
    },
    type: 'object',
    required: ['artefact_group_id'],
    title: 'Body_start_biz_artefact_management_get_artefacts_tree_start_post'
} as const;

export const Body_start_biz_artefact_management_get_history_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        limit: {
            type: 'integer',
            title: 'Limit',
            default: 10
        },
        offset: {
            type: 'integer',
            title: 'Offset',
            default: 0
        }
    },
    type: 'object',
    required: ['artefact_id'],
    title: 'Body_start_biz_artefact_management_get_history_start_post'
} as const;

export const Body_start_biz_artefact_management_remove_artefact_group_start_postSchema = {
    properties: {
        artefact_group_id: {
            type: 'string',
            title: 'Artefact Group Id'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: ['artefact_group_id'],
    title: 'Body_start_biz_artefact_management_remove_artefact_group_start_post'
} as const;

export const Body_start_biz_artefact_management_remove_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: ['artefact_id'],
    title: 'Body_start_biz_artefact_management_remove_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_rename_artefact_group_start_postSchema = {
    properties: {
        artefact_group_id: {
            type: 'string',
            title: 'Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: ['artefact_group_id', 'name'],
    title: 'Body_start_biz_artefact_management_rename_artefact_group_start_post'
} as const;

export const Body_start_biz_artefact_management_rename_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: ['artefact_id', 'name'],
    title: 'Body_start_biz_artefact_management_rename_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_restore_historical_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        revision: {
            type: 'string',
            title: 'Revision'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: ['artefact_id', 'revision'],
    title: 'Body_start_biz_artefact_management_restore_historical_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_update_artefact_content_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        file_: {
            type: 'string',
            format: 'binary',
            title: 'File '
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: ['artefact_id', 'file_'],
    title: 'Body_start_biz_artefact_management_update_artefact_content_start_post'
} as const;

export const Body_start_biz_artefact_management_update_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        content: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: ['artefact_id'],
    title: 'Body_start_biz_artefact_management_update_artefact_start_post'
} as const;

export const Body_start_biz_entities__entity_type___entity_id___attribute__restore_postSchema = {
    properties: {
        revision: {
            type: 'string',
            title: 'Revision'
        }
    },
    type: 'object',
    required: ['revision'],
    title: 'Body_start_biz_entities__entity_type___entity_id___attribute__restore_post'
} as const;

export const Body_start_dashboard_dashboard_mgt_update_dashboard_start_postSchema = {
    properties: {
        dashboard_id: {
            type: 'string',
            title: 'Dashboard Id'
        },
        widgets: {
            items: {
                '$ref': '#/components/schemas/Widget'
            },
            type: 'array',
            title: 'Widgets'
        }
    },
    type: 'object',
    required: ['dashboard_id', 'widgets'],
    title: 'Body_start_dashboard_dashboard_mgt_update_dashboard_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_create_business_entity_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        metadata: {
            '$ref': '#/components/schemas/BusinessEntityMeta'
        },
        definition: {
            items: {
                '$ref': '#/components/schemas/BusinessEntityFieldDefinition'
            },
            type: 'array',
            title: 'Definition'
        }
    },
    type: 'object',
    required: ['domain_id', 'metadata', 'definition'],
    title: 'Body_start_domain_business_entity_mgt_create_business_entity_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_delete_business_entity_start_postSchema = {
    properties: {
        business_entity_id: {
            type: 'string',
            title: 'Business Entity Id'
        },
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['business_entity_id', 'domain_id'],
    title: 'Body_start_domain_business_entity_mgt_delete_business_entity_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_get_business_entities_by_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_domain_business_entity_mgt_get_business_entities_by_domain_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_get_business_entity_start_postSchema = {
    properties: {
        business_entity_id: {
            type: 'string',
            title: 'Business Entity Id'
        },
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['business_entity_id', 'domain_id'],
    title: 'Body_start_domain_business_entity_mgt_get_business_entity_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_update_business_entity_start_postSchema = {
    properties: {
        business_entity_id: {
            type: 'string',
            title: 'Business Entity Id'
        },
        metadata: {
            '$ref': '#/components/schemas/BusinessEntityMeta'
        },
        definition: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/BusinessEntityFieldDefinition'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Definition'
        },
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['business_entity_id', 'metadata', 'definition', 'domain_id'],
    title: 'Body_start_domain_business_entity_mgt_update_business_entity_start_post'
} as const;

export const Body_start_domain_domain_mgt_create_domain_start_postSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['name'],
    title: 'Body_start_domain_domain_mgt_create_domain_start_post'
} as const;

export const Body_start_domain_domain_mgt_delete_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_domain_domain_mgt_delete_domain_start_post'
} as const;

export const Body_start_domain_domain_mgt_get_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_domain_domain_mgt_get_domain_start_post'
} as const;

export const Body_start_domain_domain_mgt_update_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_domain_domain_mgt_update_domain_start_post'
} as const;

export const Body_start_domain_label_mgt_create_label_start_postSchema = {
    properties: {
        label: {
            '$ref': '#/components/schemas/Label'
        },
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['label', 'domain_id'],
    title: 'Body_start_domain_label_mgt_create_label_start_post'
} as const;

export const Body_start_domain_label_mgt_get_labels_by_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_domain_label_mgt_get_labels_by_domain_start_post'
} as const;

export const Body_start_domain_label_mgt_get_labels_by_topic_start_postSchema = {
    properties: {
        topic: {
            '$ref': '#/components/schemas/Topic'
        },
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['topic', 'domain_id'],
    title: 'Body_start_domain_label_mgt_get_labels_by_topic_start_post'
} as const;

export const Body_start_domain_label_mgt_label_topic_start_postSchema = {
    properties: {
        label: {
            '$ref': '#/components/schemas/Label'
        },
        topic: {
            '$ref': '#/components/schemas/Topic'
        },
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['label', 'topic', 'domain_id'],
    title: 'Body_start_domain_label_mgt_label_topic_start_post'
} as const;

export const Body_start_domain_label_mgt_unlabel_topic_start_postSchema = {
    properties: {
        label: {
            '$ref': '#/components/schemas/Label'
        },
        topic: {
            '$ref': '#/components/schemas/Topic'
        },
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['label', 'topic', 'domain_id'],
    title: 'Body_start_domain_label_mgt_unlabel_topic_start_post'
} as const;

export const Body_start_domain_role_mgt_create_role_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['domain_id', 'name'],
    title: 'Body_start_domain_role_mgt_create_role_start_post'
} as const;

export const Body_start_domain_role_mgt_delete_role_start_postSchema = {
    properties: {
        role_id: {
            type: 'string',
            title: 'Role Id'
        }
    },
    type: 'object',
    required: ['role_id'],
    title: 'Body_start_domain_role_mgt_delete_role_start_post'
} as const;

export const Body_start_domain_role_mgt_get_role_start_postSchema = {
    properties: {
        role_id: {
            type: 'string',
            title: 'Role Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: ['role_id'],
    title: 'Body_start_domain_role_mgt_get_role_start_post'
} as const;

export const Body_start_domain_role_mgt_get_roles_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_domain_role_mgt_get_roles_start_post'
} as const;

export const Body_start_domain_role_mgt_update_role_start_postSchema = {
    properties: {
        role_id: {
            type: 'string',
            title: 'Role Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['role_id'],
    title: 'Body_start_domain_role_mgt_update_role_start_post'
} as const;

export const Body_start_domain_topic_mgt_create_reply_start_postSchema = {
    properties: {
        reply: {
            '$ref': '#/components/schemas/Reply'
        },
        topic: {
            '$ref': '#/components/schemas/Topic'
        },
        domain: {
            '$ref': '#/components/schemas/Domain-Input'
        }
    },
    type: 'object',
    required: ['reply', 'topic', 'domain'],
    title: 'Body_start_domain_topic_mgt_create_reply_start_post'
} as const;

export const Body_start_domain_topic_mgt_create_topic_start_postSchema = {
    properties: {
        domain: {
            '$ref': '#/components/schemas/Domain-Input'
        },
        topic: {
            '$ref': '#/components/schemas/TopicCreate'
        }
    },
    type: 'object',
    required: ['domain', 'topic'],
    title: 'Body_start_domain_topic_mgt_create_topic_start_post'
} as const;

export const Body_start_domain_topic_mgt_get_replies_on_topic_start_postSchema = {
    properties: {
        topic_title: {
            type: 'string',
            title: 'Topic Title'
        },
        domain: {
            '$ref': '#/components/schemas/Domain-Input'
        }
    },
    type: 'object',
    required: ['topic_title', 'domain'],
    title: 'Body_start_domain_topic_mgt_get_replies_on_topic_start_post'
} as const;

export const Body_start_domain_topic_mgt_get_topic_start_postSchema = {
    properties: {
        topic_title: {
            type: 'string',
            title: 'Topic Title'
        },
        domain: {
            '$ref': '#/components/schemas/Domain-Input'
        }
    },
    type: 'object',
    required: ['topic_title', 'domain'],
    title: 'Body_start_domain_topic_mgt_get_topic_start_post'
} as const;

export const Body_start_domain_topic_mgt_get_topics_by_domain_start_postSchema = {
    properties: {
        domain_id: {
            '$ref': '#/components/schemas/DomainIdSchema'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_domain_topic_mgt_get_topics_by_domain_start_post'
} as const;

export const Body_start_domain_topic_mgt_update_topic_start_postSchema = {
    properties: {
        domain: {
            '$ref': '#/components/schemas/Domain-Input'
        },
        topic: {
            '$ref': '#/components/schemas/TopicCreate'
        }
    },
    type: 'object',
    required: ['domain', 'topic'],
    title: 'Body_start_domain_topic_mgt_update_topic_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        lane_id: {
            type: 'string',
            title: 'Lane Id'
        }
    },
    type: 'object',
    required: ['process_id', 'bpmn_id', 'lane_id'],
    title: 'Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lane_by_role_id_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        role_id: {
            type: 'string',
            title: 'Role Id'
        },
        lane_id: {
            type: 'string',
            title: 'Lane Id'
        }
    },
    type: 'object',
    required: ['process_id', 'role_id', 'lane_id'],
    title: 'Body_start_process_lane_mgt_get_lane_by_role_id_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lane_start_postSchema = {
    properties: {
        lane_id: {
            type: 'string',
            title: 'Lane Id'
        }
    },
    type: 'object',
    required: ['lane_id'],
    title: 'Body_start_process_lane_mgt_get_lane_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lanes_by_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        }
    },
    type: 'object',
    required: ['process_id'],
    title: 'Body_start_process_lane_mgt_get_lanes_by_process_start_post'
} as const;

export const Body_start_process_process_element_mgt_archive_process_element_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: ['task_id'],
    title: 'Body_start_process_process_element_mgt_archive_process_element_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_event_start_postSchema = {
    properties: {
        event_id: {
            type: 'string',
            title: 'Event Id'
        }
    },
    type: 'object',
    required: ['event_id'],
    title: 'Body_start_process_process_element_mgt_delete_event_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_flow_start_postSchema = {
    properties: {
        flow_id: {
            type: 'string',
            title: 'Flow Id'
        }
    },
    type: 'object',
    required: ['flow_id'],
    title: 'Body_start_process_process_element_mgt_delete_flow_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_gateway_start_postSchema = {
    properties: {
        gateway_id: {
            type: 'string',
            title: 'Gateway Id'
        }
    },
    type: 'object',
    required: ['gateway_id'],
    title: 'Body_start_process_process_element_mgt_delete_gateway_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_task_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: ['task_id'],
    title: 'Body_start_process_process_element_mgt_delete_task_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_event_start_postSchema = {
    properties: {
        event_id: {
            type: 'string',
            title: 'Event Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: ['event_id'],
    title: 'Body_start_process_process_element_mgt_get_event_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_flow_start_postSchema = {
    properties: {
        flow_id: {
            type: 'string',
            title: 'Flow Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: ['flow_id'],
    title: 'Body_start_process_process_element_mgt_get_flow_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_gateway_start_postSchema = {
    properties: {
        gateway_id: {
            type: 'string',
            title: 'Gateway Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: ['gateway_id'],
    title: 'Body_start_process_process_element_mgt_get_gateway_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        },
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: ['process_id', 'bpmn_id', 'task_id'],
    title: 'Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_process_elements_by_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: ['process_id'],
    title: 'Body_start_process_process_element_mgt_get_process_elements_by_process_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_task_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: ['task_id'],
    title: 'Body_start_process_process_element_mgt_get_task_start_post'
} as const;

export const Body_start_process_process_element_mgt_unarchive_process_element_start_postSchema = {
    properties: {
        process_element_id: {
            type: 'string',
            title: 'Process Element Id'
        },
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: ['process_element_id', 'task_id'],
    title: 'Body_start_process_process_element_mgt_unarchive_process_element_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_event_start_postSchema = {
    properties: {
        event_id: {
            type: 'string',
            title: 'Event Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['event_id'],
    title: 'Body_start_process_process_element_mgt_update_event_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_flow_start_postSchema = {
    properties: {
        flow_id: {
            type: 'string',
            title: 'Flow Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['flow_id'],
    title: 'Body_start_process_process_element_mgt_update_flow_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_gateway_start_postSchema = {
    properties: {
        gateway_id: {
            type: 'string',
            title: 'Gateway Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['gateway_id'],
    title: 'Body_start_process_process_element_mgt_update_gateway_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_task_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['task_id'],
    title: 'Body_start_process_process_element_mgt_update_task_start_post'
} as const;

export const Body_start_process_process_mgt_create_process_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        process_definition: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Process Definition'
        }
    },
    type: 'object',
    required: ['product_id', 'name'],
    title: 'Body_start_process_process_mgt_create_process_start_post'
} as const;

export const Body_start_process_process_mgt_delete_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        }
    },
    type: 'object',
    required: ['process_id'],
    title: 'Body_start_process_process_mgt_delete_process_start_post'
} as const;

export const Body_start_process_process_mgt_deploy_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        definition_path: {
            type: 'string',
            title: 'Definition Path'
        }
    },
    type: 'object',
    required: ['process_id', 'definition_path'],
    title: 'Body_start_process_process_mgt_deploy_process_start_post'
} as const;

export const Body_start_process_process_mgt_generate_definition_start_postSchema = {
    properties: {
        prompt: {
            type: 'string',
            maxLength: 2500,
            title: 'Prompt'
        },
        process_id: {
            type: 'string',
            title: 'Process Id'
        }
    },
    type: 'object',
    required: ['prompt', 'process_id'],
    title: 'Body_start_process_process_mgt_generate_definition_start_post'
} as const;

export const Body_start_process_process_mgt_get_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: ['process_id'],
    title: 'Body_start_process_process_mgt_get_process_start_post'
} as const;

export const Body_start_process_process_mgt_get_processes_by_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        }
    },
    type: 'object',
    required: ['product_id'],
    title: 'Body_start_process_process_mgt_get_processes_by_product_start_post'
} as const;

export const Body_start_process_process_mgt_move_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        target_product_id: {
            type: 'string',
            title: 'Target Product Id'
        }
    },
    type: 'object',
    required: ['process_id', 'target_product_id'],
    title: 'Body_start_process_process_mgt_move_process_start_post'
} as const;

export const Body_start_process_process_mgt_update_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        process_definition: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Process Definition'
        }
    },
    type: 'object',
    required: ['process_id'],
    title: 'Body_start_process_process_mgt_update_process_start_post'
} as const;

export const Body_start_product_product_mgt_create_product_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['domain_id', 'name'],
    title: 'Body_start_product_product_mgt_create_product_start_post'
} as const;

export const Body_start_product_product_mgt_delete_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        }
    },
    type: 'object',
    required: ['product_id'],
    title: 'Body_start_product_product_mgt_delete_product_start_post'
} as const;

export const Body_start_product_product_mgt_get_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: ['product_id'],
    title: 'Body_start_product_product_mgt_get_product_start_post'
} as const;

export const Body_start_product_product_mgt_get_products_by_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: ['domain_id'],
    title: 'Body_start_product_product_mgt_get_products_by_domain_start_post'
} as const;

export const Body_start_product_product_mgt_update_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['product_id'],
    title: 'Body_start_product_product_mgt_update_product_start_post'
} as const;

export const Body_start_stek_stek_mgt_create_stek_start_postSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        }
    },
    type: 'object',
    required: ['name'],
    title: 'Body_start_stek_stek_mgt_create_stek_start_post'
} as const;

export const Body_start_workspace_worktree_mgt_get_worktree_start_postSchema = {
    properties: {
        workspace_id: {
            type: 'string',
            title: 'Workspace Id'
        }
    },
    type: 'object',
    required: ['workspace_id'],
    title: 'Body_start_workspace_worktree_mgt_get_worktree_start_post'
} as const;

export const BusinessEntitySchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        identity: {
            type: 'string',
            title: 'Identity'
        },
        metadata: {
            '$ref': '#/components/schemas/BusinessEntityMeta'
        },
        definition: {
            items: {
                '$ref': '#/components/schemas/BusinessEntityFieldDefinition'
            },
            type: 'array',
            title: 'Definition',
            default: []
        }
    },
    type: 'object',
    required: ['domain_id', 'identity', 'metadata'],
    title: 'BusinessEntity',
    description: 'Business entity response.'
} as const;

export const BusinessEntityFieldDefinitionSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        type: {
            '$ref': '#/components/schemas/BusinessEntityFieldType'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['name', 'type'],
    title: 'BusinessEntityFieldDefinition',
    description: 'Definition of a business entity field'
} as const;

export const BusinessEntityFieldTypeSchema = {
    type: 'string',
    enum: ['string', 'number', 'integer', 'boolean'],
    title: 'BusinessEntityFieldType',
    description: 'Field type'
} as const;

export const BusinessEntityMetaSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['name'],
    title: 'BusinessEntityMeta',
    description: 'Business entity response without the definition.'
} as const;

export const ChatbotPromptSchema = {
    properties: {
        context: {
            type: 'string',
            title: 'Context'
        },
        history: {
            items: {
                '$ref': '#/components/schemas/Message'
            },
            type: 'array',
            title: 'History'
        },
        prompt: {
            type: 'string',
            title: 'Prompt'
        }
    },
    type: 'object',
    required: ['context', 'history', 'prompt'],
    title: 'ChatbotPrompt',
    description: 'Request body for chatbot prompts'
} as const;

export const ClusterRoleSchema = {
    type: 'string',
    enum: ['user', 'user-manager'],
    title: 'ClusterRole',
    description: 'The role of the user across the organization.'
} as const;

export const ContributorSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        email: {
            type: 'string',
            title: 'Email'
        },
        date: {
            type: 'string',
            title: 'Date'
        }
    },
    type: 'object',
    required: ['name', 'email', 'date'],
    title: 'Contributor',
    description: 'An author or committer of a HistoryEntry.'
} as const;

export const CreateConnectionSchema = {
    properties: {
        name: {
            type: 'string',
            enum: ['createConnection'],
            const: 'createConnection',
            title: 'Name',
            default: 'createConnection'
        },
        label: {
            type: 'string',
            title: 'Label'
        },
        source: {
            type: 'string',
            title: 'Source'
        },
        target: {
            type: 'string',
            title: 'Target'
        }
    },
    type: 'object',
    required: ['label', 'source', 'target'],
    title: 'CreateConnection',
    description: 'Function to create a connection between two elements.'
} as const;

export const CreateEntitySchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        type: {
            type: 'string',
            title: 'Type'
        },
        description: {
            type: 'string',
            title: 'Description'
        }
    },
    type: 'object',
    required: ['name', 'type', 'description'],
    title: 'CreateEntity',
    description: 'Function to create a connection between two elements.'
} as const;

export const CreateGatewaySchema = {
    properties: {
        previous_element: {
            type: 'string',
            title: 'Previous Element'
        },
        label: {
            type: 'string',
            title: 'Label'
        },
        connection_label: {
            type: 'string',
            title: 'Connection Label'
        },
        name: {
            type: 'string',
            enum: ['createGateway'],
            const: 'createGateway',
            title: 'Name',
            default: 'createGateway'
        }
    },
    type: 'object',
    required: ['previous_element', 'label', 'connection_label'],
    title: 'CreateGateway'
} as const;

export const CreateTaskSchema = {
    properties: {
        previous_element: {
            type: 'string',
            title: 'Previous Element'
        },
        label: {
            type: 'string',
            title: 'Label'
        },
        connection_label: {
            type: 'string',
            title: 'Connection Label'
        },
        name: {
            type: 'string',
            enum: ['createTask'],
            const: 'createTask',
            title: 'Name',
            default: 'createTask'
        },
        role: {
            type: 'string',
            title: 'Role'
        }
    },
    type: 'object',
    required: ['previous_element', 'label', 'connection_label', 'role'],
    title: 'CreateTask'
} as const;

export const CreateUserSchema = {
    properties: {
        email: {
            type: 'string',
            title: 'Email'
        },
        name: {
            type: 'string',
            title: 'Name'
        }
    },
    type: 'object',
    required: ['email', 'name'],
    title: 'CreateUser',
    description: 'Create a new user.'
} as const;

export const DashboardSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        widgets: {
            items: {
                '$ref': '#/components/schemas/Widget'
            },
            type: 'array',
            title: 'Widgets',
            default: []
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Dashboard',
    description: 'Dashboard within MyStekz.'
} as const;

export const Domain_InputSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Domain',
    description: 'Request body for Domain.'
} as const;

export const Domain_OutputSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Domain',
    description: 'Request body for Domain.'
} as const;

export const DomainIdSchemaSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        }
    },
    type: 'object',
    required: ['name'],
    title: 'DomainIdSchema'
} as const;

export const DomainInTreeSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        products: {
            items: {
                '$ref': '#/components/schemas/ProductInTree'
            },
            type: 'array',
            title: 'Products'
        }
    },
    type: 'object',
    required: ['identity', 'name', 'products'],
    title: 'DomainInTree',
    description: 'Domain representation inside worktree, does not describe Domain.'
} as const;

export const DomainRoleSchema = {
    properties: {
        role_name: {
            type: 'string',
            title: 'Role Name'
        },
        domain_name: {
            type: 'string',
            title: 'Domain Name'
        },
        authorized: {
            type: 'boolean',
            title: 'Authorized'
        }
    },
    type: 'object',
    required: ['role_name', 'domain_name', 'authorized'],
    title: 'DomainRole',
    description: 'The domain roles in relation to the user.'
} as const;

export const EntityInfoSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        entity_type: {
            '$ref': '#/components/schemas/EntityType'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        parent: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/EntityInfo'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: ['identity', 'entity_type', 'name'],
    title: 'EntityInfo',
    description: 'Entity information.'
} as const;

export const EntityTypeSchema = {
    type: 'string',
    enum: ['organization', 'stek', 'domain', 'product', 'role', 'process', 'task', 'gateway', 'event', 'flow', 'artefact', 'artefact_group', 'business_entity', 'document'],
    title: 'EntityType'
} as const;

export const HTTPValidationErrorSchema = {
    properties: {
        detail: {
            items: {
                '$ref': '#/components/schemas/ValidationError'
            },
            type: 'array',
            title: 'Detail'
        }
    },
    type: 'object',
    title: 'HTTPValidationError'
} as const;

export const HateoasSchema = {
    properties: {
        href: {
            type: 'string',
            title: 'Href'
        },
        type: {
            type: 'string',
            title: 'Type'
        }
    },
    type: 'object',
    required: ['href', 'type'],
    title: 'Hateoas',
    description: 'Response body for Hoteos.'
} as const;

export const HistoryEntrySchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        subject: {
            type: 'string',
            title: 'Subject'
        },
        body: {
            type: 'string',
            title: 'Body'
        },
        author: {
            '$ref': '#/components/schemas/Contributor'
        },
        committer: {
            '$ref': '#/components/schemas/Contributor'
        }
    },
    type: 'object',
    required: ['id', 'subject', 'body', 'author', 'committer'],
    title: 'HistoryEntry',
    description: 'A value object which represents a point in time of the artefact.'
} as const;

export const LabelSchema = {
    properties: {
        title: {
            type: 'string',
            title: 'Title'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        color: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Color'
        }
    },
    type: 'object',
    required: ['title', 'description', 'color'],
    title: 'Label',
    description: `Labels are used to categorize topics

A label is unique for the combination of domain and title (composite key)
repo is e.g. com_stekz/steks/mystekz/biz/main`
} as const;

export const LaneSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        role_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Role Id'
        }
    },
    type: 'object',
    required: ['identity', 'bpmn_id', 'name'],
    title: 'Lane',
    description: 'Request body for Lane.'
} as const;

export const LinkPreviewSchema = {
    properties: {
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        image: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Image'
        },
        domain: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        }
    },
    type: 'object',
    title: 'LinkPreview'
} as const;

export const MessageSchema = {
    properties: {
        role: {
            type: 'string',
            enum: ['system', 'user', 'assistant'],
            title: 'Role'
        },
        content: {
            type: 'string',
            title: 'Content'
        }
    },
    type: 'object',
    required: ['role', 'content'],
    title: 'Message'
} as const;

export const OrganizationSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        parent_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Id'
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Organization',
    description: 'Organization within MyStekz.'
} as const;

export const ProcessSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        process_definition: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Process',
    description: 'Request body for Product.'
} as const;

export const ProcessElementSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            '$ref': '#/components/schemas/ProcessElementType'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: ['identity', 'bpmn_id', 'name', 'type'],
    title: 'ProcessElement',
    description: 'Request body for Task.'
} as const;

export const ProcessElementTypeSchema = {
    type: 'string',
    enum: ['task', 'gateway', 'event', 'flow'],
    title: 'ProcessElementType'
} as const;

export const ProcessEventSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            '$ref': '#/components/schemas/ProcessElementType',
            default: 'event'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: ['identity', 'bpmn_id', 'name'],
    title: 'ProcessEvent'
} as const;

export const ProcessFlowSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            '$ref': '#/components/schemas/ProcessElementType',
            default: 'flow'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: ['identity', 'bpmn_id', 'name'],
    title: 'ProcessFlow'
} as const;

export const ProcessGatewaySchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            '$ref': '#/components/schemas/ProcessElementType',
            default: 'gateway'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: ['identity', 'bpmn_id', 'name'],
    title: 'ProcessGateway'
} as const;

export const ProcessInTreeSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'ProcessInTree',
    description: 'Process representation inside worktree, does not describe Process.'
} as const;

export const ProcessTaskSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            '$ref': '#/components/schemas/ProcessElementType',
            default: 'task'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: ['identity', 'bpmn_id', 'name'],
    title: 'ProcessTask'
} as const;

export const ProductSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Product',
    description: 'Request body for Product.'
} as const;

export const ProductInTreeSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        processes: {
            items: {
                '$ref': '#/components/schemas/ProcessInTree'
            },
            type: 'array',
            title: 'Processes'
        }
    },
    type: 'object',
    required: ['identity', 'name', 'processes'],
    title: 'ProductInTree',
    description: 'Product representation inside worktree, does not describe Product.'
} as const;

export const PublicKeySchema = {
    properties: {
        pubkey: {
            type: 'string',
            title: 'Pubkey'
        }
    },
    type: 'object',
    required: ['pubkey'],
    title: 'PublicKey',
    description: 'Request body for adding a public SSH key.'
} as const;

export const ReplySchema = {
    properties: {
        body: {
            type: 'string',
            title: 'Body'
        },
        modified: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Modified'
        },
        created: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created'
        }
    },
    type: 'object',
    required: ['body', 'modified', 'created'],
    title: 'Reply',
    description: 'Replies are conversations on a topic.'
} as const;

export const RoleSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Role',
    description: 'Request body for Role.'
} as const;

export const StekSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        }
    },
    type: 'object',
    required: ['identity', 'name'],
    title: 'Stek',
    description: 'Request body for Stek.'
} as const;

export const TopicSchema = {
    properties: {
        title: {
            type: 'string',
            title: 'Title'
        }
    },
    type: 'object',
    required: ['title'],
    title: 'Topic',
    description: 'Topics are the center of discucsions and comments'
} as const;

export const TopicCreateSchema = {
    properties: {
        title: {
            type: 'string',
            title: 'Title'
        },
        body: {
            type: 'string',
            title: 'Body'
        }
    },
    type: 'object',
    required: ['title', 'body'],
    title: 'TopicCreate',
    description: 'Schema for creating a Topic.'
} as const;

export const TopicResponseSchema = {
    properties: {
        title: {
            type: 'string',
            title: 'Title'
        },
        body: {
            type: 'string',
            title: 'Body'
        },
        created: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Created'
        },
        modified: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Modified'
        },
        author: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Author'
        }
    },
    type: 'object',
    required: ['title', 'body', 'created', 'modified', 'author'],
    title: 'TopicResponse',
    description: 'Response schema a Topic.'
} as const;

export const UserSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        email: {
            type: 'string',
            title: 'Email'
        },
        role: {
            '$ref': '#/components/schemas/ClusterRole'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        _actions: {
            items: {
                '$ref': '#/components/schemas/Action'
            },
            type: 'array',
            title: ' Actions'
        }
    },
    type: 'object',
    required: ['identity', 'email', 'role', 'name'],
    title: 'User',
    description: 'User model.'
} as const;

export const ValidationErrorSchema = {
    properties: {
        loc: {
            items: {
                anyOf: [
                    {
                        type: 'string'
                    },
                    {
                        type: 'integer'
                    }
                ]
            },
            type: 'array',
            title: 'Location'
        },
        msg: {
            type: 'string',
            title: 'Message'
        },
        type: {
            type: 'string',
            title: 'Error Type'
        }
    },
    type: 'object',
    required: ['loc', 'msg', 'type'],
    title: 'ValidationError'
} as const;

export const WidgetSchema = {
    properties: {
        x: {
            type: 'integer',
            title: 'X'
        },
        y: {
            type: 'integer',
            title: 'Y'
        },
        w: {
            type: 'integer',
            title: 'W'
        },
        h: {
            type: 'integer',
            title: 'H'
        },
        content: {
            type: 'string',
            title: 'Content'
        }
    },
    type: 'object',
    required: ['x', 'y', 'w', 'h', 'content'],
    title: 'Widget',
    description: 'Widget within a Dashboard.'
} as const;

export const WorktreeSchema = {
    properties: {
        stek_id: {
            type: 'string',
            title: 'Stek Id'
        },
        domains: {
            items: {
                '$ref': '#/components/schemas/DomainInTree'
            },
            type: 'array',
            title: 'Domains'
        }
    },
    type: 'object',
    required: ['stek_id', 'domains'],
    title: 'Worktree',
    description: `A worktree represents the hierarchy of a system, described in terms of
domains, products and processes. It can be used to render a tree view of
the system.

Note, the schema does not expose the branch that is used across all
entities (stek and its domains), unlike the domain entity.`
} as const;